// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3gn7L","header":"MergedInvoice_header__1OGnO"};